import { render, staticRenderFns } from "./MisTableBox.vue?vue&type=template&id=869af9ac"
import script from "./MisTableBox.vue?vue&type=script&lang=js"
export * from "./MisTableBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports